export const SET_USER = 'SET_USER'
export const SET_LOADING = 'SET_LOADING'
